module.exports = __webpack_public_path__ + "img/seller_view interests.ab0c9480.svg";